var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DatePicker',_vm._b({staticClass:"datepicker",class:{
    'datepicker--error': _vm.error,
    'datepicker--not-original': _vm.notOriginal,
    'datepicker--design-new': _vm.design === 'new'
  },attrs:{"format":_vm.format,"title-format":_vm.format,"value-type":_vm.valueType,"time-title-format":_vm.timeTitleFormat,"lang":_vm.lang,"popup-class":_vm.resolvedPopupClass},on:{"input-error":function($event){return _vm.$emit('input-error', $event)},"change":function($event){return _vm.$emit('input-valid')}},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}},'DatePicker',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }